import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-uikit-cdn',
  templateUrl: './uikit-cdn.component.html',
  styleUrls: ['./uikit-cdn.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class UikitCdnComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/features/uikit-cdn/uikit-cdn.component.ts